import AgencySaleAddOrderScreen from 'features/Agency/screens/AgencySaleAddOrderScreen';
import AgencySaleDetailScreen from 'features/Agency/screens/AgencySaleDetailScreen';
import AgencySaleOrderListScreen from 'features/Agency/screens/AgencySaleOrderListScreen';
import { Route, Routes } from 'react-router-dom';

function ManageOrder(props) {
  return (
    <div>
      <Routes>
        <Route path="" element={<AgencySaleOrderListScreen />} />
        <Route path="/add" element={<AgencySaleAddOrderScreen />} />
        <Route path="/add/:saleId" element={<AgencySaleAddOrderScreen />} />
        <Route path="/:saleId" element={<AgencySaleDetailScreen showSidebar={true} />} />
        <Route path="/agency-sale-add-order" element={<AgencySaleAddOrderScreen />} />
        <Route path="*" element={<>Not found</>} />
      </Routes>
    </div>
  );
}

export default ManageOrder;
